
import { defineComponent, computed, provide } from 'vue'
import { useStore } from 'vuex'
import { DefaultApolloClient } from '@vue/apollo-composable'
import AppLayout from '@/layouts/AppLayout.vue'
import { InMemoryCache } from '@apollo/client/cache'
import { ApolloLink, createHttpLink, ApolloClient } from '@apollo/client/core'
import { setContext } from 'apollo-link-context'

export default defineComponent({
    name: 'App',
    components: {
        AppLayout,
    },
    setup() {
        const store = useStore()
        const colorMode = computed(() => store.getters['ui/colorMode'])

        const environment = process.env.NODE_ENV

        const httpLink: ApolloLink = createHttpLink({
            uri: 'https://gateway.paperback.moe/graphql',
        })

        const authLink = setContext((_, { headers }) => {
            const oidcIsAuthenticated = computed(
                () => store.getters['auth/oidcIsAuthenticated']
            )
            const oidcAccessToken = computed(
                () => store.getters['auth/oidcAccessToken']
            )

            let token = ''
            if (oidcIsAuthenticated.value && oidcAccessToken.value) {
                token = oidcAccessToken.value
            } else {
                return
            }
            return {
                headers: {
                    ...headers,
                    Accept: 'charset=utf-8',
                    Bearer: token,
                },
            }
        })

        const client = new ApolloClient({
            link: authLink.concat(httpLink as any) as any, // TODO fix types
            cache: new InMemoryCache(),
        })

        provide(DefaultApolloClient, client)

        return {
            colorMode,
            environment,
        }
    },
})
